import { render } from "./LogsComponent.vue?vue&type=template&id=dc259216"
import script from "./LogsComponent.vue?vue&type=script&lang=js"
export * from "./LogsComponent.vue?vue&type=script&lang=js"

import "./LogsComponent.vue?vue&type=style&index=0&id=dc259216&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__